import React from 'react'

import CreatePromotion from '../../../containers/promotions/create/CreatePromotion'

export default class CreatePromotionPane extends React.Component {
  public render() {
    return (
      <CreatePromotion />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/promotions/create/CreatePromotionPane.tsx